var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgPublished = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14Zm3.214-8.778a.525.525 0 1 0-.828-.644L7.58 9.184a.175.175 0 0 1-.256.023L5.551 7.61a.525.525 0 0 0-.702.78l1.774 1.597c.529.476 1.35.403 1.787-.158l2.804-3.607Z",
  fill: "#3CA632"
})));
export default SvgPublished;